<template>
  <v-container fluid pa-0 mt-0 fill-height>
    <v-layout wrap row justify-content-center>
      <rHeader
        v-if="globals"
        :title_first_line="$t(globals.header)"
        :title_second_line="$t(globals.header2)"
        :herb_image="globals.herb"
        :header_image="globals.topimage"
      ></rHeader>
      <v-flex xl10 md10 sm12 xs12 v-if="branches && branches.length">
        <rBranchList :branches="branches" v-if="branches" :globals="globals" :style="{
      'background-color': (this.$store.state.high_contrast) ? 'black' : 'white',
      'border-radius': '10px',
      'border': (this.$store.state.high_contrast) ? '1px solid yellow' : '1px solid lightgray', 
      }"></rBranchList>
      </v-flex>
      <v-flex xl10 md10 sm12 xs12 v-if="branches && !branches.length">
        <v-card>
          <v-card-title>
            {{ $t('no_branches_avaliable') }}
          </v-card-title>
        </v-card>
      </v-flex>
      <rFooter :footer_left="$t(globals.footer_left)" :footer_right="$t(globals.footer_right)"></rFooter>
    </v-layout>
  </v-container>
</template>

<script>
import RemoteData from "../mixins/remotedata";
export default {
  name: "Branches",
  data: function() {
    return {
      branches: null
    };
  },
  props: ["globals"],
  mixins: [
    RemoteData({
      branches: env.apiLinks.branches
    })
  ],
  watch: {
    branches: function(val) {
      let visible = 0;
      let visibleID = null;
      if (val && val.length > 0) {
        val.forEach(branch => {
          if (branch.status === "Widoczny") {
            visible++;
            visibleID = branch.id;
          }
        });
        if (visible == 1) {
          this.$router.push(`/branch/${visibleID}`);
        }
      }else{
        this.showErrorMessage('error:', this.$t('no_branches_avaliable'));
      }
    }
  }
};
</script>

<style>
body {
  display: flex;
  flex-direction: column;
}

/*
 *  STYLE 3
 */

#style-3::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
	background-color: #000000;
}

</style>